import { Col, Container, Row } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import complang1 from "../assets/img/complang1.svg";
import complang2 from "../assets/img/complang2.svg";
import complang3 from "../assets/img/complang3.svg";
import complang4 from "../assets/img/complang4.svg";
import complang5 from "../assets/img/complang5.svg";
import framework1 from "../assets/img/framework1.svg";
import framework2 from "../assets/img/framework2.svg";
import framework3 from "../assets/img/framework3.svg";
import framework4 from "../assets/img/framework4.svg";
import framework5 from "../assets/img/framework5.svg";
import tools1 from "../assets/img/tools1.svg";
import tools2 from "../assets/img/tools2.svg";
import tools3 from "../assets/img/tools3.svg";
import tools4 from "../assets/img/tools4.svg";
import tools5 from "../assets/img/tools5.svg";
import lang1 from "../assets/img/lang1.svg";


export const Skills = () => {
  const responsive = {
    superLargeDesktop: {
      // the naming can be any, depends on you.
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 2, //changed from 3 to 2
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  return (
    <section className="skill" id="skills">
      <Container>
        <Row>
          <Col>
            <div className="skill-bx">
              <h2>Skills</h2>
              <p>
                I have a passion for acquiring new skills and keeping up with
                the latest advancements in technology. Currently, I am most
                proficient in using the following technical tools and
                technologies:
              </p>
              <Carousel
                responsive={responsive}
                infinite={true}
                className="skill-slider"
              >
                <div className="item">
                  <h5>Computer Languages</h5>
                  <div>
                    <img src={complang1} alt="JavaScript logo" />
                  </div>
                  <div>
                    <img src={complang2} alt="HTML logo" />
                  </div>
                  <div>
                    <img src={complang3} alt="CSS logo" />
                  </div>
                  <div>
                    <img src={complang4} alt="Sass logo" />
                  </div>
                  <div>
                    <img src={complang5} alt="C Sharp logo" />
                  </div>
                </div>
                <div className="item">
                  <h5>Frameworks</h5>
                  <div>
                    <img src={framework1} alt="React logo" />
                  </div>
                  <div>
                    <img src={framework2} alt="Bootstrap logo" />
                  </div>
                  <div>
                    <img src={framework3} alt="Express logo" />
                  </div>
                  <div>
                    <img src={framework4} alt="Node logo" />
                  </div>
                  <div>
                    <img src={framework5} alt="Mocha logo" />
                  </div>
                </div>
                <div className="item">
                  <h5>Tools</h5>
                  <div>
                    <img src={tools1} alt="Git logo" />
                  </div>
                  <div>
                    <img src={tools2} alt="GitHub logo" />
                  </div>
                  <div>
                    <img src={tools3} alt="VS Code logo" />
                  </div>
                  <div>
                    <img src={tools4} alt="Jira logo" />
                  </div>
                  <div>
                    <img src={tools5} alt="Chrome logo" />
                  </div>
                </div>
                <div className="item">
                  <h5>Human Languages & Essential "Soft Skills"</h5>
                  <img src={lang1} alt="Persian language" />
                  <div className="desc">
                    <a
                      href="https://acrobat.adobe.com/id/urn:aaid:sc:VA6C2:afb6bd5c-c63c-4a8f-8609-96a507f19004"
                      alt="Persian language certificate"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Persian
                    </a>
                  </div>
                  <div>
                    <p>Collaboration</p>
                    <p>Training and development</p>
                    <p>Feedback and evaluation</p>
                    <p>Conflict resolution</p>
                    <p>Pair programming</p>
                    <p>Cross-cultural communication</p>
                    <p>Time management</p>
                    <p>Agile Methodologies</p>
                  </div>
                </div>
              </Carousel>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
